import { jsx as _jsx } from "react/jsx-runtime";
import { withBaseIcon } from '../src/Icons.utils';
export const AlignLeft2Line = (props) => withBaseIcon(_jsx("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", role: "img", children: _jsx("path", { d: "M3.00024 20H21.0002M3.00024 12H13.0002M3.00024 4.00002H21.0002", stroke: "currentColor", strokeWidth: 2, strokeLinecap: "round", strokeLinejoin: "round" }) }), props);
AlignLeft2Line.iconName = 'align-left-2';
AlignLeft2Line.displayName = 'AlignLeft2Line';
export default AlignLeft2Line;
